import React from 'react'

function Exchanges() {
    return (
        <div>
            Exchanges here...
        </div>
    )
}

export default Exchanges
